import { SystemRole } from './user.js';
export const ROLE_CAPABILITIES = [
    {
        key: 'messages.guests',
        area: 'Messaging',
        label: 'Send guest invitations and messages',
        description: 'Send, remind and schedule invitation campaigns, and send guest broadcasts.',
        defaultAllowed: true,
    },
    {
        key: 'messages.sms',
        area: 'Messaging',
        label: 'Text guests',
        description: 'Send a guest broadcast as a text message.',
        defaultAllowed: true,
    },
    {
        key: 'messages.vendors',
        area: 'Messaging',
        label: 'Email vendors',
        description: "Write to an event's vendors from its Vendors tab.",
        defaultAllowed: true,
    },
    {
        key: 'conversations.start',
        area: 'Messaging',
        label: 'Start conversations',
        description: 'Start a new conversation about a record, or about nothing in particular.',
        defaultAllowed: true,
    },
    {
        key: 'conversations.attach',
        area: 'Messaging',
        label: 'Attach files to conversations',
        description: 'Attach library files and reports, upload files, and ask people for a file back.',
        defaultAllowed: true,
    },
];
/** The roles the grid sets. See the note above for why the others are not. */
export const CONFIGURABLE_CAPABILITY_ROLES = [SystemRole.PLANNER];
const DEFINITIONS = new Map(ROLE_CAPABILITIES.map((definition) => [definition.key, definition]));
export function isRoleCapability(value) {
    return typeof value === 'string' && DEFINITIONS.has(value);
}
export function isConfigurableCapabilityRole(role) {
    return CONFIGURABLE_CAPABILITY_ROLES.includes(role);
}
/**
 * Whether `role` may do `capability`, given the values the office has stored
 * (`stored`: capability → allowed, for that role).
 *
 * An administrator always may. A role the grid does not govern is not stopped
 * here — its own rules decide. A configurable role holds what was stored, else
 * the capability's default.
 */
export function roleMay(role, capability, stored = new Map()) {
    if (role === SystemRole.ADMIN)
        return true;
    if (!isConfigurableCapabilityRole(role))
        return true;
    return stored.get(capability) ?? DEFINITIONS.get(capability)?.defaultAllowed ?? false;
}
//# sourceMappingURL=capabilities.js.map